/* eslint-disable @typescript-eslint/no-explicit-any */

import { selectors } from '@groove-labs/groove-ui';
import { Map } from 'immutable';

import { AUTO_IMPORT_FIELDS } from 'Modules/FlowsShow/constants';

const { makeGetFieldValue } = selectors.form;

export const makeGetValidationInProgress =
  (reportSfdcId: string) =>
  (state: Map<string, any>): boolean =>
    reportSfdcId &&
    state.getIn(
      [
        'PeopleImportDialog',
        'reports',
        'validationReport',
        reportSfdcId,
        'inProgress',
      ],
      false
    );
export const makeGetReportIsValid =
  (reportSfdcId: string) =>
  (state: Map<string, any>): boolean =>
    reportSfdcId &&
    state.getIn(
      [
        'PeopleImportDialog',
        'reports',
        'validationReport',
        reportSfdcId,
        'isValid',
      ],
      false
    );
export const makeGetReportMessage =
  (reportSfdcId: string) =>
  (state: Map<string, any>): string | null =>
    reportSfdcId &&
    state.getIn(
      [
        'PeopleImportDialog',
        'reports',
        'validationReport',
        reportSfdcId,
        'message',
      ],
      null
    );
export const makeGetValidationIsDone =
  (reportSfdcId: string) =>
  (state: Map<string, any>): boolean =>
    reportSfdcId &&
    state.getIn(
      [
        'PeopleImportDialog',
        'reports',
        'validationReport',
        reportSfdcId,
        'isDone',
      ],
      false
    );

export const makeGetSelectedReportSfdcId =
  (groupId: string) =>
  (state: Map<string, any>): string | null => {
    const selectedReport = makeGetFieldValue(AUTO_IMPORT_FIELDS.REPORT)(state, {
      groupId,
    });
    return selectedReport && selectedReport.get('value');
  };
